module.exports = {
  Invalid20: '20\'的卖价不能小于成本。',
  Invalid40: '40\'的卖价不能小于成本。',
  Invalid45: '45\'的卖价不能小于成本。',
  ALL: '【全部】',
  ALLINIncludes: 'ALL IN 价格包含的附加费如下\:',
  ALLINRemarks: '备注\: ALL IN 价已包含附加费中灰色背景的费用项。',
  ALLRG: '【全部】',
  AbnormalDetected: '亲，根据系统设置的校验规则，侦测到待审核运价可能存在以下问题，欲知详情，请点击蓝色标题。',
  Accept: '接受',
  AcceptTenant: '接受方',
  AcceptTime: '接受日期',
  AcceptUser: '接受人',
  Accepted: '已接受',
  Add: '新增',
  AddCondition: '添加判断条件',
  AddFee: '新增附加费',
  AddNewCustomer: '添加新客户',
  Address: '地址',
  Agent: '代理',
  Agree: '同意申请',
  CancelAgree: '撤销同意',
  Canceled: '已撤销',
  Agreed: '已同意',
  Air: '空运',
  AirStatistics: '空运运价统计',
  Aircraft: '机型',
  AircraftFullName: '机型全称',
  Airliner: '客机',
  AlertEQAbnormal: '同条件下不同箱型价格比较出现下列情况时提醒',
  AlertPlaceAbnormal: '同POL、POD同箱型的价格比较出现下列情况时提醒',
  AlertSumAbnormal: '运价总费用出现下面情况时提醒',
  AlertValidAbnormal: '运价有效期出现下列情况时提醒',
  AllState: '【全部】',
  AllowedTier: '允许查看的等级为',
  Amount: '费用',
  Approve: '审核',
  ApproveAsync: '是否后台运行审核任务?',
  TariffRatingAtTheTimeOfMaintenance: '定义运价等级',
  ApproveSet: '审核设置',
  ApprovedBy: '审核人',
  ApprovedDate: '审核日期',
  Attachment: '附件',
  Audit: '审核',
  AuthAccept: '他人分享',
  AuthInvite: '分享他人',
  AuthInvite2: '运价分享',
  AuthAccept2: '运价订阅',
  AuthorizedClient: '委托单位',
  BOTH_EMPTY: '\t{0}行，{1}与{2}至少录一项;\n',
  Back: '返回',
  BadDays: '航程格式不正确\!',
  BasicInfo: '基本信息',
  ECommerceEta: '电商ETA',
  ECommerceEtd: '电商ETD',
  BasicPort: '基本港',
  BeginDate: '有效期',
  BeginDateCol: '有效期自',
  Big: '增大',
  BillType: '提单类型',
  BookingAgent: '订舱代理',
  Both: '预到付同价',
  Branch: '分公司',
  BusinessType: '业务类型',
  ByDate: '按时间',
  ByPort: '按港口',
  ByState: '按状态',
  CANCEL: '取消',
  CHARGES: '\t{0}行，箱型为{2}的{1}附加费输入错误;\n',
  COD: '目的国家(地区)',
  CODPrompt: '请输入卸货国家或地区',
  CODAirPrompt: '请输入目的国家或地区',
  COL: '起运国家(地区)',
  COLPrompt: '请输入起运国家或地区',
  COMMON_ERROR: '{0}行，{1}不正确;<br/>',
  CONFIRM: '确定',
  COST_VAT: '成本税率',
  CabinNature: '舱位性质',
  CabinState: '舱位状态',
  Cancel: '取消',
  CargoAircraft: '货机',
  Carrier: '船公司',
  Carrier_Air: '航空公司',
  CasePriceInvalid: '单价的卖价不能小于成本。',
  ChargeName: '费用名称',
  ChargeOfDeliveryPlace: '交货地费用',
  ChargeOfReceiptPlace: '收货地费用',
  ChargeType: '费用类型',
  ChargeUnit: '计费单位',
  ChargedWeight: '计费重量',
  Check: '检查',
  CheckApproveSet: '审核超时设置',
  CheckInterval: '轮循时间间隔',
  ChineseName: '中文名',
  Chk: '【复选框】',
  City: '城市',
  ClickMe: '单击切换查询模式。',
  ClickMeSimple: '单击切换查询模式。\n简单查询方式的运价默认有效期从今天开始，要查询其他有效期运价请进入高级查询。',
  Client: '客户',
  ClientExist: '客户名系统中已存在！',
  ClientIsEmpty: '委托单位不能为空.',
  ClientName: '客户名称',
  Close: '关闭',
  ClosingDay: '截关日',
  Code: '代码',
  Collect: '到付',
  Coloader: '同行',
  ColoaderMin: '同行(Min)',
  ColoaderPrice: '同行价',
  ColoaderRate: '同行(Rate)',
  ColumnName: '列名',
  Commodity: '货物',
  Common: '普货',
  CompareTime: '开始时间必须小于结束时间\!',
  CompareValidate: '有效期的结束时间必须大于开始时间\!',
  FreeTimeType: '免箱期类型',
  PleaseInput: '请输入{0}的值。',
  NeedFreeBox: '免用箱{0}天混用',
  FreeTimeCalculatedSeparately: '免堆期{0}天，免用箱{1}天',
  Contact: '联系人',
  ContinueApprove: '继续审核',
  ContractNo: '约号',
  Copy: '复制',
  CopyPriceNo: '复制单号',
  CopyQuotation: '复制报价单',
  CopySetting: '复制配置',
  Cost: '成本',
  Cost20: '20\'成本',
  Cost40: '40\'成本',
  Cost45: '45\'成本',
  CostHC: '40\'HC成本',
  CostMin: '成本(Min)',
  CostPrice: '成本价',
  CostRate: '成本(Rate)',
  Country: '国家',
  CountryPrompt: '请输入起运国家或地区',
  CreatedBy: '录入人',
  CreatedDate: '创建日期',
  Currency: '币种',
  CurrentPrice: '已发布',
  CurrentPriceEditSucceed: '已发布运价修改成功，它的状态自动变为待审核运价，你需要重新批准。',
  CurrentTenant: '本公司',
  CustomConfig: '自定义...',
  CustomerMin: '直客(Min)',
  CustomerPrice: '直客价',
  CustomerRate: '直客(Rate)',
  CyCy: 'CY-CY',
  CyDoor: 'CY-DOOR',
  CyRamp: 'CY-RAMP',
  Dangerous: '危险品',
  DangerousClass: '危险品等级',
  DataGridConfig: '自定义显示列',
  Day: '日',
  Days: '航程',
  DaysColSea: '航程(天)',
  DaysUnitSea: '航程(天)',
  DaysValidate: '航程不能为空.',
  DecodeMarkupFailed: '运价审核配置解析失败\!',
  DelFee: '删除此附加费',
  DelRate: '删除运价',
  Delete: '删除',
  DeleteCfg: '删除此配置项',
  DepartureDay: '船期',
  DepartureDay2: '船期2',
  DepartureDayOfAir: '航班时刻',
  DepartureDayOfAir2: '二程航班时刻',
  CargoAircraft2: '二程货机',
  AircraftOrFreighter: '客机/货机',
  FreighterOrAircraft: '货机/客机',
  AirlinerNB: '客机（NB）',
  DesCharge: '目的地费用',
  Dest: '卸货港',
  DestinationDock: '目的港挂靠码头',
  Detail: '【详情】',
  DetailOfFCL: '整箱运价详情',
  DetailOfLCL: '拼箱运价详情',
  Details: '详情',
  DifferentCarrier: '审核的运价属于多个船公司，是否继续?',
  DifferentCarrierAndRegion: '审核的运价属于多个船公司和{0}，是否继续?',
  DifferentCarrierAndRegions: '审核的运价属于多个船公司、起运和卸货区域，是否继续?',
  DifferentPOD: '选中的价格卸货港不完全相同，是否继续？',
  DifferentPOL: '选中的价格起运港不完全相同，是否继续？',
  DifferentRegion: '审核的运价属于多个{0}，是否继续?',
  Direct: '直达',
  DirectCustomer: '直客',
  Dock: '挂靠码头',
  Dockland: '港区',
  DocumentCategory: '文档类型',
  DocumentId: '导入源文档流水号',
  DuplicateFees: '附加费{0}重复\!',
  DuplicateShare: '你已经分享运价给{0}, 无需重复操作。',
  EMPTY_DATATABLE: '\t服务器没有{0}的相关数据，请联系系统管理员;\n',
  EQAbnormal: '同条件下不同箱型价格比较存在异常；',
  EQMustDifferent: '箱型不能相同',
  EQ_TYPE_SIZE: '\t行与列为{0}的箱型{1}不正确;\n',
  EXISTS_SAME_TIME: '\t{0}行，{1}与{2}不能同时录入;\n',
  EXISTS_SAME_TIME2: '{0}与{1}不能同时录入。',
  Edit: '编辑',
  EffectiveDate: '生效日期',
  EffectiveDateType: '生效日期类型',
  Email: '电邮',
  EndDate: '至',
  EndDateAlign: 'right',
  EndDateCol: '有效期止',
  EndTime: '结束时间',
  EnglishName: '英文名',
  EqSize: '箱型',
  EqType: '箱种',
  Error: '错误',
  ErrorCfg: '配置存在错误，请核查。',
  ErrorRaised: '错误产生。',
  ExceedMaxAmount: '程序没有在后台运行审核时最多一次审核300条数据.',
  ExistLoop: '存在循环设置',
  ExpirationDate: '失效日期',
  ExpirationDateType: '失效日期类型',
  Export: '导出Excel',
  ExportByTemplate: '按模板导出',
  ExportMode: '请选择运价数据导出方式',
  ExportPDF: '导出PDF',
  ExtraInfo: '附加信息',
  ExtraLoadFailed: '附加信息加载失败\!',
  FCL: '整箱',
  FCLStatistics: '整箱运价统计',
  FIELD_TOO_LONG: '\t{0}行，{1}长度过长，最大允许长度为{2};\n',
  FORMAT_NOT_MATCHING: '\t{0}行，{1}格式不正确;\n',
  Fair: '持平',
  Fall: '下降',
  FaultCode: '错误号\:',
  FaultMessage: '信息\:',
  Fax: '传真',
  FeeFclPrompt: '请输入费用简称',
  FeeIndex: '顺序号',
  FeeMin: '费用(Min)',
  FeeName: '费用名称',
  FeeNameIsNull: '请录入费用名称。',
  FeeRate: '费用(Rate)',
  FeeUnit: '计费单位',
  FeeUnitIsNull: '请录入计费单位。',
  Fees: '费用',
  FileHistory: '文件历史',
  FileName: '文档名称',
  FileSize: '文档大小',
  Find: '查找',
  Finished: '操作完成。',
  Flight: '服务项目',
  FreeTime: '免柜租期',
  FreightTerm: '运输条款',
  Fri: '周五',
  Friday: '周五',
  GenerateCharge: '订舱时生成费用',
  Goods: '品名',
  GoodsLevel: '等级',
  GreaterThanZero: '数值必须大于0\!',
  GroupNo: '所属组号',
  HCInvalid: '40\'HC的卖价不能小于成本。',
  HasApproved: '已审核。',
  HasDeleted: '已删除。',
  Hazard: '危险品',
  HeadLiftAircraft: '头程客机',
  HiddenCost: '不可以查看其他分公司成本。',
  Hour: '时',
  Hours: '小时',
  IS_EMPTY: '\t{0}行，{1}不能为空;\n',
  EXIST_THE_SAME_TIME: '\t{0}行，{1}和{2}数量不同;\n',
  IS_LESS: '\t{0}行，{1}不能小于{2};\n',
  IS_SAME: '\t{0}行，{1}不能与{2}相同;\n',
  IWantShare: '我要分享运价给',
  Import: 'Excel导入',
  GeekYumImport: '导入极羽运价',
  OneStackImport: '导入壹沓运价',
  InactiveRate: '单号有删除线的价格已失效！',
  InputValue: '请输入！',
  Invalid: '失效',
  InvalidSelection: '将选中的数据设为无效状态？',
  InviteTenant: '邀请方',
  InviteUser: '邀请人',
  IsActive: '是否激活',
  IsAllowedOperate: '你没有审核或删除起运港为{0}、卸货港为{1}的运价权限！',
  IsAllowedOperate_DiffBranch: '你不能修改别的分公司录入的运价！',
  IsApproveRecord: '是否审核选中数据?',
  IsApproveRecords: '是否审核选中数据?',
  IsBooked: '是否生成订单',
  IsCopy: '你要复制选中的报价单吗?',
  IsDeleteRecord: '是否删除选中数据?',
  IsDeleteRecords: '是否删除选中数据?',
  IsMarkup: '你确实要加价吗?',
  KPIEmail: 'KPI考评报表收件人',
  LCL: '拼箱',
  Lane: '航线代码',
  LatestTemplateVersion: '模板的最新版本号是{0}',
  Level: '等级',
  LoadSucceed: '成功导入系统\!\n',
  LocalCharge: '本地费用',
  MUST_EMPTY: '\t{0}行，根据{2}的数值，{1}必须留空;\n',
  ManualAudit: '手工加价审核',
  ECommerceFareOfflineReminder: '已发布电商运价下线提醒',
  ECommerceFareOfflineReminderContent: '相关船司电商运价审核通过时会将之前已发布的电商运价下线，本批审批通过的电商运价将是同一船司唯一发布的电商运价。',
  PleaseSelectDataForTheSameTariffType: '请选择相同运价类型的数据',
  MarketPrice: '市场价',
  Markup: '加价',
  MarkupBy: '幅度加价',
  MarkupRate: '统一加价',
  MarkupTo: '加价至',
  MarkupType: '加价类型',
  MaxMailPerDay: '每天最多邮件提醒',
  MaxQueryCount: '只显示了部分数据，请增加检索条件过滤\!',
  MaxQueryCount2: '只抓取了前{0}条数据，请点击\'查看\'按钮结束查询，或点击\'更多\'按钮继续查询，最多查询10000条价格，请尽可能缩小查询范围。',
  Measurement: '尺寸',
  MinCharge: 'MINIMUM',
  MinimumInvalidLCL: '最低价不能大于重量价或体积价',
  MinimumPrice: '最低价',
  ModifiedBy: '修改人',
  ModifiedDate: '修改日期',
  Mon: '周一',
  Monday: '周一',
  Month: '月',
  MoreSetting: '高级设置',
  MustDifferent: '{0}与{1}不能相同\!',
  NA: 'NA',
  NOT_ALLOWED_NEGATIVE: '\t{0}行，{1}不能小于0;\n',
  NOT_ALLOWED_UPLOAD: '\t不允许上传{0}的运价;\n',
  NO_CONFIGURATION_CHARGES: '\t服务器没有配置附加费{0}，请联系系统管理员;\n',
  NO_FIELD: '\t表格中缺少{0};\n',
  NO_OF: '\t{0}行，表格缺少箱型为{1}的OF;\n',
  NO_SUM: '\t{0}行，箱型为{1}的SUM是必填项;\n',
  NStep: 'N等级',
  NaCode: 'NAC',
  NeedCheckApproveCfg: '时系统不检查是否有新运价未及时审核，1时系统自动检查。',
  NeedCheckValidityCfg: '0时运价审核前不检查有效性，1时运价审核前检查运价有效性。',
  NeedMarkupCfg: '0时运价审核后不分层，1时运价审核后生成多层运价。',
  NetConnectionFailed: '系统没有连接到服务器，请求发送失败.',
  NewRate: '新增运价',
  Next: '下一步',
  No: '否',
  NoChargeAndPrice: '请录入价格信息或费用信息。',
  NoExchangeRate: '系统中未维护{0}汇率.',
  NoHit: '没有找到匹配项\!',
  NoLabel: '更多',
  NoPODCharge: '没有目的港收费信息！',
  NoRecord: '没有数据。',
  TariffTableExportLevelTitleTips: '导出运价表提示',
  TariffTableExportLevelTips: '当前正在导出【运价等级：{0}】的运价。',
  PleaseSelectTheExpirationDateFirst: '请先选择有效期。',
  EitherETDOrValidityPeriodMustBeFilledIn: 'ETD或有效期两者必填其一',
  theSelectedValidityPeriodCannotExceed3Months: '选择的有效期时间跨度不能超过3个月。',
  theSelectedETDCannotExceed3Months: '选择的ETD时间跨度不能超过3个月。',
  NoRecordSelect: '没有选择数据\!',
  NoRecordUpload: '表格中没有找到可供上传的运价！',
  NoSetting: '请去配置页面增加PFMarkupSetting配置。',
  NoSettingSelect: '请勾选配置项\!',
  NoSurcharge: '费用{0}未找到.',
  NoTax: '所有价格不含税，具体税率以承运人最后收取为准。',
  NoTierChange: '运价等级没有变化。',
  NotAccepted: '待接受',
  NotAllowed: '你不可以访问此等级运价.',
  NotAllowedCopy: '你不可以复制他人的报价单。',
  NotAllowedDelete: '你不能删除其他用户录入的运价！',
  NotAllowedDifferentCarrierAndRegion: '运价包含多个船公司和{0}，不允许审核\!',
  NotAllowedDifferentCarrierAndRegions: '运价包含多个船公司、起运和卸货区域，不允许审核\!',
  NotAllowedDifferentRegions: '运价包含多个{0}，不允许审核\!',
  NotAllowedFromCountry: '你不可以查看起运港在此国家的运价！',
  NotAllowedFromRegion: '你不可以查看起运港在此区域的运价！',
  NotAllowedInput: '你没有新增此起运港的权限.',
  NotAllowedPOD: '你不可以查看此目的港的运价！',
  NotAllowedPOL: '你不可以查看此起运港的运价！',
  NotAllowedPOD2: '你不可以查看目的港({0})的运价！',
  NotAllowedPOL2: '你不可以查看起运港({0})的运价！',
  NotAllowedToCountry: '你不可以查看目的港在此国家的运价！',
  NotAllowedToRegion: '你不可以查看目的港在此区域的运价！',
  NotAuth: '你的权限不够。',
  NotCheck: '待审核',
  NotQuotationToOthers: '请不要向其他销售的客户报价。',
  NotRequired: '不设置',
  NotSameLength: '{0}与{1}个数不同.',
  NotSave: '你的操作没有保存，是否保存修改？',
  Num: '数量',
  Num20: '20\'数量',
  Num40: '40\'数量',
  Num45: '45\'数量',
  NumHC: '40\'HC数量',
  OK: '确定',
  Origin: '起运港',
  OtherInfo: '其它信息',
  FreeContainerPeriod: '免箱期',
  OvertimeApprove: '超时提醒',
  Owner: '所属销售',
  POD: '目的港',
  PODCharge: '目的港收费',
  PODCity: '目的城市',
  PODCityPrompt: '请输入目的城市',
  PODCodeChanged: '卸货港的代码无法与系统中数据匹配，这条运价可能失效了\!',
  PODCountry: '目的港国家(地区)',
  PODIsNull: '请输入卸货港！',
  PODPrompt: '请输入卸货港',
  PODs: '多目的港',
  POL: '起运港',
  POLCity: '起运城市',
  POLCityPrompt: '请输入起运城市',
  POLIsNull: '请输入起运港！',
  POLPrompt: '请输入起运港',
  PODPrompt2: '请输入目的港',
  POLs: '多起运港',
  PasteQuotation: '粘贴报价单',
  PasteSetting: '粘贴配置',
  PaymentTerm: '付费条款',
  PendingPrice: '待审核',
  Phone: '电话',
  PlaceAbnormal: '同POL、POD同箱型的价格比较存在异常；',
  PlaceOfDelivery: '交货地',
  PlaceOfReceipt: '收货地',
  PleaseSelectBookingAgent: '请选择代理',
  PlsChangeSystemCfg: '请在系统配置页面修改默认配置，启用需要的设置。',
  PlsConfigDetail: '请详细设置订阅条件！',
  PlsInput: '请录入{0}.',
  PlsInputClient: '请录入客户信息。',
  PlsInputCode: '请输入接受方的公司全称或代码\!',
  PlsInputPOLPOD: '请在\'基本信息\'页面录入起运港和卸货港\!',
  PlsInputPersonalInfo: '客户的联系人和联系电话不能为空！',
  PlsInputQuotationNo: '请输入报价单号',
  PlsInputRemark: '输入备注信息',
  PlsInputUserInfo: '请将个人资料填写完整。',
  PlsSelect: '请选择',
  PlsSelectOF: '请选择一条运价信息作为海运费.',
  PlsSelectOffice: '请选择您需要订阅的（分）公司\:',
  PlsSelectRecord: '请选择记录\!',
  PlsSelectRejectEQ: '请选择拒接的箱型',
  PlsSelectRule: '请选择一条加价规则\!',
  PlsSelectTenant: '请选择您需要订阅的合作伙伴\:',
  PlsSelectValue: '请选择！',
  PlsSetEmail: '设置您要接收订阅信息的邮箱\:',
  PlsSubscribe: '请订阅你感兴趣的信息，当运价更新后您将收到提醒邮件。',
  PodRegion: '目的港区域',
  Port: '港口',
  PortPrompt: '请输入港口',
  Prepaid: '预付',
  PriceDateType: '有效期基准',
  volumeWeightRatio: '体积重量比',
  minRateValue: '最小计费单位',
  PleaseNumber: '请填写数字',
  F: '有效期按货物上驳船计',
  M: '有效期按货物上母船计',
  PriceInfo: '运价信息',
  PriceLoadFailed: '未能正常加载运价！',
  PriceNo: '运价号',
  PriceNoIsNull: '请输入运价单号！',
  PriceNoPrompt: '请输入运价单号或后7位',
  PriceSetting: '运价配置',
  PriceState: '运价状态',
  PriceState_Common: '正常',
  PriceState_Inquiry: '询价',
  PriceState_Lack: '紧张',
  PriceState_Overbooked: '爆舱',
  PriceState_Reject: '不接',
  PriceState_Suspend: '停航',
  PriceTrend: '价格趋势',
  Print: '打印',
  Query: '查询',
  QueryRecords: '查询到{0}条记录。',
  Quotation: '报价',
  QuotationClient: '临时客户',
  QuotationDate: '报价时间',
  QuotationNo: '报价单号',
  QuotationValidFrom: '报价单有效期',
  RATE_TYPE_ERROR: '\t{0}行，{1}不正确，上传的Excel文件与当前页面运价类型不同或者当前上传的Excel运价不是最新模板;\n',
  REGION_NO_POD: '\t{0}行，POD所属的区域为{1}与表格中的卸货区域(ROD)不符;\n',
  REGION_NO_POL: '\t{0}行，POL所属的区域为{1}与表格中的起运区域(ROL)不符;\n',
  ROD: '目的区域',
  ROD_EQ: '卸货区域或箱型',
  ROL: '起运区域',
  Rate: '费率',
  RateByCost: '成本费率',
  RateDetails: '运费详情',
  RateGrade: '运价级别',
  RateValidation: '运价有效性验证',
  ReallyWantAccept: '你确定接受{0}分享的运价吗?',
  ReallyWantAgree: '你确定同意{0}申请的运价吗?',
  ReallyWantCancelAccept: '你真的要取消查看{0}分享的运价吗?',
  ReallyWantCancelShare: '你真的要不再分享运价给{0}吗?',
  ReallyWantChange: '你确定将运价等级调整为{0}吗?',
  ReallyWantRefuse: '你确定拒绝{0}申请的运价吗?',
  ReallyWantShare: '你确定分享运价给{0}吗?',
  ReceivingInstructions: '接货特殊说明',
  ReceivingType: '接货特殊说明类型',
  Records: '表{0}中{1}条记录,',
  Refresh: '刷新',
  RefreshFinished: '刷新完毕',
  Refuse: '拒绝申请',
  RefuseRemark: '拒绝原因',
  Refused: '已拒绝',
  Region: '区域',
  RegionOrCarrier: '区域或船公司',
  RejectRate: '有删除线的价格处于拒接状态，请慎重！',
  RemarkAreaToolTip: '双击可放大查看，再双击复原。',
  Remarks: '备注',
  ECommerceRemarks: '电商价备注',
  TraditionalRemarks: '线下价备注',
  RemoteBooking: '新建委托',
  Reset: '重置',
  Rise: '上升',
  Route: '区域',
  RouteAndPODEmpty: '航线和卸货港不能同时为空\!',
  RouteAndPODEmpty1: '请保证起运港、目的港、航线、船公司（航空公司）、订舱代理（运价来源）至少填写1个。',
  RouteAndPODEmpty2: '请保证起运港、目的港、航线 至少填写1个。',
  SELL_VAT: '卖价税率',
  SUM_NOT_EQUAL: '\t{0}行，箱型为{1}的总费用不等于各附加费总和;\n',
  SaleState: '特价状态',
  Sales: '销售',
  Sat: '周六',
  Saturday: '周六',
  Save: '保存',
  SaveQuotation: '请先保存报价单！',
  SavedSucceed: '已保存。',
  ApplyAgree: '审核同意生效',
  ApplyRefuse: '审核拒绝生效',
  CancelAgreed: '撤销同意生效',
  ScheduleDetails: '船期',
  ScheduleInfo: '船期信息',
  SchemeAudit: '方案加价审核',
  Search: '搜索\:',
  SelectRoute: '请选择区域\!',
  SelectTerm: '请选择付费条款\!',
  SelectTransportMode: '请选择运输方式\!',
  Self: '自营',
  Sell: '卖价',
  ServiceCode: 'ServiceCode',
  ServiceMode: 'ServiceMode',
  Setting: '设置',
  SettingDuplicate: '重复设置',
  SettingNoEQ: '被勾选的行缺少箱种\!',
  SettingNoRegion: '被勾选的行缺少{0}\!',
  SettingOverlap: '被勾选的两个配置存在重复\!',
  Share: '共舱',
  ShareCarriers: '共舱船公司',
  ShareRemark: '分享说明',
  ShareRemarks: '※分享说明双方可见',
  ShareState: '状态',
  ShareToPrompt: '请输入你分享运价的接受方\!',
  ShareWithMyself: '你无需分享运价给自己所在的公司\!',
  ShippingClause: '运输条款',
  ShippingLine: 'Outport Code',
  ShippingSchedule: '船期',
  Small: '收缩',
  Source: '运价来源',
  SpecialPrice: '特价',
  StartTime: '开始时间',
  StatBeginDate: '时间段',
  StatBeginDateByDate: '录入时间段',
  StatBeginDateByPort: '有效期时间段',
  StatEndDate: '至',
  StatSucceed: '操作成功\!',
  State: '运价状态',
  Statistics: '统计',
  SubContractNo: 'CODE',
  SubmittedBy: '提交人',
  SubmittedDate: '提交时间',
  Subscribe: '订阅',
  SubscribeCondition: '订阅条件',
  SubscribeFromTenant: '订阅人所属Tenant',
  SubscribePOD: '卸货地',
  SubscribePOL: '起运地',
  SubscribeType: '订阅类型',
  Subscriber: '订阅人',
  Sum: '费用合计',
  SumAbnormal: '运价总费用存在异常；',
  Sun: '周日',
  Sunday: '周日',
  Surcharge: '附加费',
  SurchargeLoadFailed: '附加费加载失败\!',
  Suspend: '停航',
  SuspendRate: '灰色背景色的价格已停航！',
  SuspendSelection: '将选中的价格设为 {0}状态？',
  TSport: '中转港',
  TaskStart: '审核任务已经发送到后台,请稍后到已发布页签查询数据\!',
  Template: '下载模板',
  TenantPrompt: '请输入Tenant',
  Three_BE_One: '三级运价不能小于一级运价！',
  Three_BE_Two: '三级运价不能小于二级运价！',
  Three_B_One: '三级运价必须大于一级运价！',
  Thu: '周四',
  Thursday: '周四',
  Times: '次',
  Tips: '提示',
  TotalAmount: '记录数',
  TradeLane: '航线',
  TransferPort: '中转港',
  TransportMode: '运输方式',
  Tue: '周二',
  Tuesday: '周二',
  Two_BE_One: '二级运价不能小于一级运价！',
  Two_B_One: '二级运价必须大于一级运价！',
  UnNo: 'UNNO',
  UnitPrice: '单价',
  UploadFailed: '上传失败。',
  UploadSucceed: '上传成功。',
  VALIDITY_ERROR: '\t{0}行, {1}只允许输入未来两个月内的运价;\n',
  VALIDITY_LESS: '\t{0}行, "{1}"不能小于"Valid fm";\n',
  VAT: '税率',
  ValidAbnormal: '运价有效期存在异常；',
  Validation: '有效性',
  ValidityCfgLoadError: '运价有效性验证的配置数据下载失败！',
  VatIncluded: '含税',
  VatInvalid: '卖价税率不能小于成本税率',
  Via: '中转港',
  View: '查看',
  Visible: '可见',
  Volume: '体积',
  VolumeCost: '体积价成本',
  VolumePrice: '体积价',
  WYSIWYG: '所见即所得',
  WantApply: '申请运价方名称',
  Warning: '警告',
  Wed: '周三',
  Wednesday: '周三',
  Week: '本周',
  Weight: '重量(KG)',
  WeightCost: '重量价成本',
  WeightLimitInfo: '限重信息',
  WeightLimitLoadFailed: '限重信息加载失败\!',
  WeightPrice: '重量价',
  WeightRule: '限重规则',
  Weight_LCL: '重量',
  Wrong: '不正确！',
  WrongInput: '输入错误！',
  EtaMustBeLaterThanOrEqualToEtd: 'ETA需晚于或等于ETD',
  Yes: '是',
  YesLabel: '查看',
  amsEns: 'AMS/ENS',
  inviteTime: '邀请日期',
  jobTypeExport: '出口',
  jobTypeImport: '进口',
  overloadRemarks: '超重说明',
  quantity: '件数',
  resetDataGrid: '重置表格',
  selectedCount: '当前选中了{0}条记录。',
  AcceptTenant2: '订阅方',
  AcceptUser2: '订阅方操作者',
  AcceptTime2: '运价分享生效日期',
  InviteTenant2: '分享方',
  InviteUser2: '分享方操作者',
  inviteTime2: '发起邀请/申请日期',
  customSpecs: '自定义规格',
  reject: '拒接',
  fclRateSearch: '整箱运价查询',
  onlyViewAndEditCostAreAllow: '只允许查看和编辑成本运价',
  SubscribePOLType: '起运地类型',
  DestinationType: '目的地类型',
  Destination: '目的地',
  OtherCharge: '其他费用',
  priceNoPrompt: '请输入运价号或后7位',
  polOrPodOrRegionOneMustBeEntered: '起运港，目的港，航线必须录入一项',
  costAndSumInvalidSave: '卖价小于成本\n是否确认保存',
  pleaseChooseOtherOfficeData: '未选择数据，或选择其他分公司数据.',
  noSelectedPrice: '未选择运价.',
  BelongingCity: '所在城市',
  UpdateQuotationValidity: '是否按运价有效期更新报价单有效期到期日？',
  CheckQuotationDeleteTip: '已生成订单的报价单不允许删除！',
  PlsSelectAirOF: '请选择一条运价信息作为空运费.',
  NotMatchChargeItem: '没有匹配的费用名称({0}),请在收费项目模块中维护平台代码【{1}】！',
  AirFreight: '空运费',
  WarExpenses: '战争费',
  FuelSurcharge: '燃油附加费',
  WarehousingFee: '入仓费',
  SeaFreight: '海运费',
  QuotationWeightAndCubageLessZero: '报价单重量和体积不能小于0!',
  Name: '名称',
  MatchType: '匹配方式',
  PriceType: '运价类型',
  priceNature: '运价性质',
  TraditionalFreightRates: '线下运价',
  Traditional: '线下',
  ECommerce: '电商',
  SpotFreightRates: '电商运价',
  ConfigureTheSurcharge: '配置附加费',
  ConfigureTheSurchargeTips: '可以配置列表上需要展示的附加费',
  SpotContainerWeightTips: '电商运价集装箱重量默认：18,000KG',
  TariffTableExportExcelTips: '由于数据量原因，建议先选择有效期，且时间跨度不超过3个月',
  PolCountry: '起运港国家',
  PolRegion: '起运港区域',
  PodCountry: '目的港国家',
  PriceProfile: '策略信息',
  SharingProfile: '分享策略',
  SelectProfile: '选择策略',
  ViewProfile: '查看策略',
  PodCity: '目的港城市',
  weightVolume: '货物比重',
  DestinationAgent: '目的港代理',
  warehouse: '仓库',
  WarehouseName: '仓库名称',
  WarehouseAddress: '仓库地址',
  WarehouseMap: '仓库地图',
  warehouseContact: '仓库联系人',
  FlightInformationManagement: '航班信息管理',
  FlightNo: '航班号',
  ClosingTime: '截单时间',
  DepartureTime: '起飞时间',
  ArrivalTime: '到达时间',
  SizeLimit: '尺寸限制',
  SingletonWeightLimit: '单件重量限制',
  ChemicalPkggReq: '化工品包装需求',
  LithiumBatteryReq: '锂电池需求',
  TimeWarning: '到达时间必须大于起飞时间',
  AirDay: '天数',
  flightNumber: '航班号不能为空',
  emptyTime: '此处为当地时间。',
  BatchImportQuotations: '批量导入报价单',
  XSuccessfulXFailed: '成功【{0}】条，失败【{1}】条！',
  ErrorVolumeWeightRatio: '体积重量比输入错误！',
  AirPriceServiceItem: '导入失败，空运运费服务项目中没有维护任何数据，请先维护数据',
  HsCode: 'HSCODE'
}
